import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import ApplicationRequest from 'pages/ApplicationRequest/AppRequest';
import ProcessedRequestsView from 'pages/AnnualUserAccessReview/views/Review/ProcessedRequests/ProcessedRequestsView';

const UarSubmitFlowOverlay = ({
	open,
	mode,
	container,
	onRequestClose,
	onConfirmClose,
	onCancelClose,
	showCloseConfirmation,
	onProcessedDone,
}) => {
	const location = useLocation();
	const actionFlowRequestKey = `${location.pathname}${location.search}`;
	const isModifyMode = mode === 'modify';

	const onCloseConfirmationCloseHandler = (_, reason) => {
		if (reason !== 'backdropClick') {
			onCancelClose();
		}
	};

	return (
		<>
			<Dialog
				open={open}
				container={container}
				onClose={onRequestClose}
				disableEscapeKeyDown
				scroll='paper'
				fullWidth={!isModifyMode}
				maxWidth={isModifyMode ? 'lg' : 'md'}
				sx={{
					'& .MuiDialog-paper': {
						width: isModifyMode
							? 'min(1180px, calc(100vw - 48px))'
							: 'auto',
						height: isModifyMode
							? 'min(860px, calc(100vh - 48px))'
							: 'auto',
						maxHeight: 'calc(100vh - 48px)',
						display: 'flex',
						flexDirection: 'column',
					},
				}}
			>
				<DialogTitle
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						pb: 1,
						position: 'sticky',
						top: 0,
						zIndex: 1,
						backgroundColor: 'background.paper',
					}}
				>
					<Typography variant='h6'>
						{isModifyMode
							? 'Complete Modify Requests'
							: 'Requests Processed'}
					</Typography>
					<IconButton
						onClick={onRequestClose}
						size='small'
						aria-label='close submit flow overlay'
					>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<DialogContent
					dividers={!isModifyMode}
					sx={{
						p: isModifyMode ? 0 : 2,
						overflow: 'auto',
						display: 'flex',
						minHeight: 0,
					}}
				>
					{isModifyMode ? (
						<Box sx={{ width: '100%', minHeight: 0 }}>
							<ApplicationRequest key={actionFlowRequestKey} />
						</Box>
					) : (
						<ProcessedRequestsView
							embedded
							onBackToReview={onProcessedDone}
							onBackToHome={onProcessedDone}
						/>
					)}
				</DialogContent>
			</Dialog>

			<Dialog
				open={showCloseConfirmation}
				onClose={onCloseConfirmationCloseHandler}
				maxWidth='xs'
				fullWidth
			>
				<DialogTitle>Leave submission flow?</DialogTitle>
				<DialogContent>
					<Typography variant='body2'>
						Closing now can interrupt your progress through queued requests.
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={onCancelClose} variant='text'>
						Stay Here
					</Button>
					<Button onClick={onConfirmClose} variant='contained' color='warning'>
						Leave Flow
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

UarSubmitFlowOverlay.propTypes = {
	open: PropTypes.bool,
	mode: PropTypes.oneOf(['modify', 'processed']),
	container: PropTypes.any,
	onRequestClose: PropTypes.func,
	onConfirmClose: PropTypes.func,
	onCancelClose: PropTypes.func,
	showCloseConfirmation: PropTypes.bool,
	onProcessedDone: PropTypes.func,
};

UarSubmitFlowOverlay.defaultProps = {
	open: false,
	mode: 'modify',
	container: undefined,
	onRequestClose: () => {},
	onConfirmClose: () => {},
	onCancelClose: () => {},
	showCloseConfirmation: false,
	onProcessedDone: () => {},
};

export default UarSubmitFlowOverlay;